<div class="modal fade" id="dialogMemorialItem" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        Itens do lote {{memorial?.descricao}}
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-12">
            <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-info">
              <i class="fa fa-plus"></i> Incluir item
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <th style="width: 75%" scope="col">Item</th>
                  <th style="width: 60px" scope="col">Quantidade</th>
                  <th style="width: 120px" scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of memorial?.itens; let idx = index">
                  <!-- produto -->
                  <td *ngIf="!item.editavel">
                    {{item.produto.codigo}} {{funcaoService.abreviarStr(item.descricao, 100, true)}}
                  </td>
                  <td *ngIf="item.editavel">
                    <p-autoComplete #produto_item_ id="rec" [(ngModel)]="item.produto" [forceSelection]="true"
                      [autoHighlight]="true" [ngModelOptions]="{standalone: true}"
                      [field]="produtoAutoComplete.conversor" [suggestions]="produtoAutoComplete.lista"
                      (completeMethod)="produtoAutoComplete.filtrar($event)"
                      inputStyleClass="form-control form-control-sm" minLength="2"
                      [style]="{ width: 'calc(100% - 32px)', float: 'left' }">
                      <ng-template let-produto pTemplate="item">
                        {{produto.codigo}} {{produto.nome}}
                      </ng-template>
                    </p-autoComplete>
                    <button (click)="abrirConsultaProduto()" class="btn btn-sm btn-outline-secondary float-right"
                      type="button" style="border-bottom-left-radius: 0px;  border-top-left-radius: 0px;"
                      title="Busca avançada ou inclusão de novo produto/serviço">
                      <i class="fa fa-search-plus"></i>
                    </button>
                  </td>

                  <!-- quantidade -->
                  <td *ngIf="!item.editavel" class="text-right">{{+item.quantidade | number:'1.0-0'}}
                  </td>
                  <td *ngIf="item.editavel">
                    <input #quantidade_ [(ngModel)]="item.quantidade" [ngModelOptions]="{standalone: true}" type="text"
                      (keydown.enter)="salvar(item)" class="form-control form-control-sm" unmask="typed"
                      [imask]="imaskQtd">
                  </td>

                  <td class="text-right">
                    <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
                      <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
                    </button>
                    <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary">
                      <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
                    </button>
                    <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
                      <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                    </button>
                    <button *ngIf="!item.editavel" (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary">
                      <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

<lib-produto-busca-dlg [login]="login" (callback)="callbackProduto($event)"></lib-produto-busca-dlg>